let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("yxfEy")).then(() => parcelRequire('7YJX2'));